import actionConstants from '../constants/ActionConstants';

export default function setGlobalLoader(active) {
  const type = active
    ? actionConstants.SHOW_LOADER_GLOBAL
    : actionConstants.HIDE_LOADER_GLOBAL;
  return { type };
}